export default {
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '서비스명',
    companyName: '판매사업자',
    representative: '대표자명',
    address: '소재지',
    contact: '문의처',
    paymentTerms: '대금의 지급방법 및 지급시기',
    deliverySchedule: '상품의 인도시기',
    sellingPrice: '상품 등의 판매가격',
    shippingFee: '배송료',
    additionalFee: '판매가격・배송료 등 외에 필요한 요금',
    salesRestrictions: '판매기간・판매수량의 제한',
    returnsAndCancellations: '반품・취소',
    otherConditions: '기타 조건'
  }
};
